import at from 'array.prototype.at';
import hasOwn from 'object.hasown';

if (!Object.hasOwn) {
  hasOwn.shim();
}

if (!Array.prototype.at) {
  at.shim();
}

export default defineNuxtPlugin({});
